/**
 * The Verb used for the HTTP request
 */
export var RequestVerb;
(function (RequestVerb) {
    /**
     * HTTP GET method
     */
    RequestVerb["GET"] = "GET";
    /**
     * HTTP PUT method
     */
    RequestVerb["PUT"] = "PUT";
    /**
     * HTTP POST method
     */
    RequestVerb["POST"] = "POST";
    /**
     * HTTP DELETE method
     */
    RequestVerb["DELETE"] = "DELETE";
    /**
     * HTTP PATCH method
     */
    RequestVerb["PATCH"] = "PATCH";
})(RequestVerb || (RequestVerb = {}));
/**
 * The target of the HTTP call
 */
export var BackendTarget;
(function (BackendTarget) {
    BackendTarget["M365AdminCenter"] = "MAC";
    BackendTarget["Mover"] = "Mover";
    BackendTarget["ExchangeAdminCenter"] = "EAC";
    BackendTarget["SharepointAdminCenter"] = "SPO";
    BackendTarget["TeamsAdminCenter"] = "TAC";
    BackendTarget["ComplianceAdminCenter"] = "CAC";
    BackendTarget["SecurityAdminCenter"] = "SAC";
    BackendTarget["ProductivityAdminCenter"] = "PAC";
    BackendTarget["GraphApi"] = "Graph";
    BackendTarget["VRoomApi"] = "VRoom";
    BackendTarget["DeviceCareApi"] = "DeviceCare";
    BackendTarget["RecommendationApi"] = "Reco";
    BackendTarget["M365AoboApi"] = "M365Aobo";
    BackendTarget["Assist"] = "Assist";
    BackendTarget["BusinessApplicationPlatform"] = "PPACBap";
    BackendTarget["PowerPlatformConfigService"] = "PPACConfigService";
    BackendTarget["PowerPlatformAPITenantLevel"] = "ppapi-tenant-level";
    BackendTarget["PowerPlatformAPIEnvironmentLevel"] = "ppapi-environment-level";
    BackendTarget["PowerPlatformAPITenantLevelPreProd"] = "ppapi-tenant-level-preprod";
    BackendTarget["PowerPlatformAPIEnvironmentLevelPreProd"] = "ppapi-environment-level-preprod";
    BackendTarget["DynamicsCRM"] = "dynamics-crm";
    BackendTarget["LicensingAPI"] = "LicAPI";
    BackendTarget["PPApiTenantLevel"] = "PPApiTenantLevel";
    BackendTarget["Fusion"] = "Fusion";
    BackendTarget["VivaPulse"] = "VivaPulse";
    BackendTarget["CloudPolicyServiceApi"] = "OCPS";
    BackendTarget["ECS"] = "ECS";
    BackendTarget["O365ShellServices"] = "O365Shell";
    BackendTarget["ProfileService"] = "ProfileService";
    BackendTarget["VsbHub"] = "VsbHub";
    BackendTarget["Augloop"] = "Augloop";
    BackendTarget["EmbeddedFinanceService"] = "EmbeddedFinanceService";
    BackendTarget["AzureResourceManager"] = "ARM";
    BackendTarget["SubstrateSearchService"] = "3S";
    BackendTarget["Tulips"] = "Tulips";
    BackendTarget["M365Rewards"] = "M365Rewards";
    BackendTarget["DevicesMgmtApi"] = "DevicesMgmtApi";
    BackendTarget["Recommender"] = "Recommender";
    BackendTarget["UnifiedAdminApp"] = "UnifiedAdminApp";
})(BackendTarget || (BackendTarget = {}));
/**
 * When this is used as request URL, then a token response should be sent
 */
export var TokenOnlyRequestUrl = '__token__';
